import * as actionTypes from './actionTypes';

export const setOpenDrawer = (open) => {
  return {
    type: actionTypes.SET_DRAWER_OPEN,
    open: open
  };
};